require('./myWallet.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');

// @components
const ProductTypesTab = require('./myWalletTabs/productTypesTab');
const EvolutionModal = require('./evolutionModal/myWalletEvolutionModal');
const AssetAllocationTab = require('./myWalletTabs/assetAllocationTab');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @core
const { FormattedText , formatText } = require('core/i18n').i18n;

// @utilities
const { taggingEventHandled } = require('utilities/taggingEventHandled');

const {
    ACTIVE_TAB_CONTRACTS,
    ASSET_ACTIVE_TAB,
    BROKER_CORPORATE_OPERATIONS_URL,
} = require('constants/index');

class MyWallet extends React.Component {
    constructor(props) {
        super(props);
        this.buildDerechosInfo = this.buildDerechosInfo.bind(this);
        this.buildCorpOpRedirectLink = this.buildCorpOpRedirectLink.bind(this);
    }

    buildCorpOpRedirectLink() {
        return (
            <OKLink inverse={true} to={BROKER_CORPORATE_OPERATIONS_URL}>
                <FormattedText value="broker-derechosCoopsLinkText"/>
            </OKLink>
        );
    }

    buildDerechosInfo() {
        const { immBrokerMyInvestments, showRightsInfo, toggleRightsInfo } = this.props;
        const rightAssociated = immBrokerMyInvestments.get('isRightsAssociated');

        if (rightAssociated) {
            return (
                <section className="my-wallet__derechos-info">
                    <OKMessage type="informative"
                        modifier="dark-bg"
                        closeButton={true}
                        visible={showRightsInfo}
                        onCloseButtonClick={toggleRightsInfo}
                    >
                        <FormattedTextWithComponents
                            value="broker-hasDerechosInfoText"
                            injectedComponents={[this.buildCorpOpRedirectLink()]}
                        />
                    </OKMessage>
                </section>
            );
        }
    }

    getContent() {
        const {
            immBrokerMyInvestments,
            immMyWalletCharts,
            onHandleRetry,
            onToggleModal,
            brokerMyInvestmentsErrorReceived,
            isFetchingMyInvestment,
            prevActiveTabValue,
            flagBasedFeatures
        } = this.props;
        let { activeTab } = this.props;

        if(activeTab == ACTIVE_TAB_CONTRACTS) {
            activeTab = prevActiveTabValue;
        }

        if (activeTab !== ASSET_ACTIVE_TAB) {
            return (<ProductTypesTab
                immStocksByType={this.props.immStocksByType}
                immMyWalletCharts={immMyWalletCharts}
                immBrokerMyInvestments={immBrokerMyInvestments}
                handleRetry={onHandleRetry}
                onToggleModal={onToggleModal}
                key="actualTab"
                brokerMyInvestmentsErrorReceived={brokerMyInvestmentsErrorReceived}
                isFetchingMyInvestment={isFetchingMyInvestment}
                flagBasedFeatures={flagBasedFeatures}
            />);
        }
        return (<AssetAllocationTab
            immStocksByType={this.props.immStocksByType}
            immMyWalletCharts={immMyWalletCharts}
            immBrokerMyInvestments={immBrokerMyInvestments}
            immFlagBasedFeatures={flagBasedFeatures}
            handleRetry={onHandleRetry}
            onToggleModal={onToggleModal}
            key="actualTab"
            brokerMyInvestmentsErrorReceived={brokerMyInvestmentsErrorReceived}
            isFetchingMyInvestment={isFetchingMyInvestment}
        />);

    }

    onClickEvolutionCharButton(onToggleEvolutionModal) {
        taggingEventHandled(this.props.pageName, 'myPortfolioCard', 'seeEvolution');

        return onToggleEvolutionModal();
    }

    render() {
        const {
            immBrokerMyInvestments,
            immMyWalletCharts,
            getEvolutionData,
            onToggleEvolutionModal,
            immBrokerCustomWalletPortfolios,
            activeTab
        } = this.props;
        const myWalletTitle = formatText('myWallet-title');
        const evolutionModaleIsOpen = immMyWalletCharts.get('showEvolutionModal');
        const tab = this.getContent(activeTab);

        return (
            <div>
                <div className="my-wallet__wrapper">
                    {this.buildDerechosInfo()}
                    <ContentBox
                        title={myWalletTitle}
                        customClassName={"my-wallet"}
                    >
                        {tab}
                    </ContentBox>
                    <section className="my-wallet__footer content-box__footer">
                        <OKLink modifier="widget" onClick={() => this.onClickEvolutionCharButton(onToggleEvolutionModal)}>
                            <FormattedText value="brokerMyWallet-myWalletSeeCurrentValueEvolution" />
                        </OKLink>
                    </section>
                </div>
                <EvolutionModal
                    getEvolutionData={getEvolutionData}
                    evolutionState={immMyWalletCharts}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                    immBrokerCustomWalletPortfolios={immBrokerCustomWalletPortfolios}
                    key="evolutionTab"
                    isOpen={evolutionModaleIsOpen}
                    onRequestClose={onToggleEvolutionModal}
                    onToggleEvolutionModal={onToggleEvolutionModal}
                />
            </div>
        );
    }
}

MyWallet.propTypes = {
    immMyWalletCharts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immStocksByType: PropTypes.object.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.any.isRequired,
    onHandleRetry: PropTypes.func.isRequired,
    getEvolutionData: PropTypes.func.isRequired,
    onToggleModal: PropTypes.func,
    onToggleEvolutionModal: PropTypes.func,
    brokerMyInvestmentsErrorReceived: PropTypes.bool,
    isFetchingMyInvestment: PropTypes.bool,
    toggleRightsInfo: PropTypes.func,
    showRightsInfo: PropTypes.bool,
    activeTab: PropTypes.number,
    prevActiveTabValue: PropTypes.bool,
    pageName: PropTypes.string,
    flagBasedFeatures: PropTypes.object
};

module.exports = MyWallet;
